<div class="flex items-center justify-between mt--8">
  <div class="flex items-center">
    <mat-icon svgIcon="find_in_page" class="mr-8"></mat-icon>
    <div class="mat-subtitle-2 mb-0 fs-24 mt-4 fw-600">{{'TEST_RESULTS.EF_TEST' | transloco}}
      @if (showRunbook) {
        <span>({{ (efTestResults?.length || 0)}})</span>
      }
    </div>

  </div>
  @if (showRunbook) {
    <div class="flex flex-row gap-3 create-runbook">
        <button class="flex accent h-32 mt-16 mr-8" [ngClass]="{'disable': instance?.availabilityState ? (instance?.availabilityState !== AvailabilityStatus.RUNNING || isEFTestInprogress || (data?.status | isNotIn: EXCECUTETEST_ENABLE_STATES)) : isEFTestInprogress || (data?.status | isNotIn: EXCECUTETEST_ENABLE_STATES)}" 
        matTooltipClass="above" matTooltipPosition="above" [matTooltip]="(isEFTestInprogress || !EXCECUTETEST_ENABLE_STATES.includes(data?.status)) ? ('TEST_RESULTS.EF_TEST_TOOLTIP' | transloco) : null"
        (click)="(isEFTestInprogress || !EXCECUTETEST_ENABLE_STATES.includes(data?.status)) ? '' : excecuteEFTest()">
            {{'TEST_RESULTS.EXCECUTE_TEST' | transloco}}
        </button>
        <div class="flex items-center border-left mr-4"></div>
    <div class="refresh-circle rounded-full w-32 h-32 flex items-center justify-center cursor-pointer" (click)="refreshClick()">
      <mat-icon svgIcon="refresh" class="icons transition-transform duration-700" [ngClass]="{ 'animate-spin': isRefreshing }"></mat-icon>
    </div>
    <app-environment-paginator [length]="efTestResults?.length" [pageIndex]="pageIndex" [pageSize]="paginationSize" (page)="onPageChange($event)"></app-environment-paginator>
    </div>
  }
</div>

<mat-divider class="neutral-2 mt-12 mb-12 ml-4 mr-4"></mat-divider>
@if (efResponse && !showLoader) {
<div class="flex flex-col border-radius route-table mb-16 mt-8">
  <app-environment-table class="runbook-table" [ngClass]="{'disabled': showLoader}" [displayColumns]="displayColumns" [showSkeletonLoader]="runbookLoading" [instance]="instance" [initialDataSource]="efTestResults" [dataLoading]="runbookLoading" [dataSourceLength]="showRunbook" [initialCreate]="efTestResults?.length === 0" (sorted)="resetPaginator()" (pageModify)="onTablePageChanged($event)" (pageChanged)="onPageChange($event)"></app-environment-table>
</div>
}
@if (!efResponse && !apiNotFound && !showLoader && showRunbook) {
<div class="flex flex-col" >
  <div class="flex flex-col empty-panel ml-10 mr-16 mt-16">
    <div class="empty-data flex flex-col items-center mt-32 ">
      <img class="w-106" alt="efTest not found" src="/assets/images/service_not_found.png">
      <div class="flex mt-6 ">{{'SANITY_TEST.NO_EF_CREATED' | transloco }}</div>
    </div>
   </div>
</div>
}
@if (!showRunbook && !showLoader){
  <div class="flex flex-col items-center justify-center pt-8 pb-10 mt-150 fs-16">
    <mat-icon svgIcon="report_problem" class="icon-md-2 h-50 w-50 not-supported"></mat-icon>
    <div class="mt-10 feature-not-avaliable">{{'FEATURE.FEATURE_NOT_AVAILABLE' | transloco}}</div>
  </div>
}
@if (showLoader) {
<div class="loader-section">
  <div class="runbook-group loader-header flex flex-col p-16">
    <div class="flex flex-row">
      @for (tableColumn of displayColumns; track tableColumn?.key) {
        <div class="loader-style">
          <ngx-skeleton-loader class="flex loader-line mr-80" count="1" appearance="line"></ngx-skeleton-loader>
        </div>
      }
    </div>
  </div>

  @for (item of [1, 2, 3]; track $index) {
    <div class="w-100-percent">
    <div class="runbook-group flex flex-col p-16">
      <div class="flex flex-row">
        @for (tableColumn of displayColumns; track tableColumn?.key) {
          <div class="loader-style">
            <ngx-skeleton-loader class="flex loader-line mr-80" count="1" appearance="line"></ngx-skeleton-loader>
          </div>
        }
      </div>
    </div>
    </div>
  }
</div>
}
